import {configureStore} from "@reduxjs/toolkit";
import logger from "redux-logger";
import {adminMiddleware} from "./main/components/admin/admin.middleware";
import {userSessionInitializer} from "./main/components/initialize/userSessionInitializer.middleware";
import {userSessionPersistence} from "./main/components/session/persistence/userSessionPersistence.middleware";
import {getConfig} from "./main/utils/envUtil";
import {applicationInitialState} from "./applicationState";
import {createRootReducer} from "./mainReducerMap";
import { isSerializable } from "./main/utils/serializableUtil";

const createLocalStore = () => {
    return configureStore({
        reducer: createRootReducer(),
        preloadedState: applicationInitialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    isSerializable,
                },
            }).concat(
                logger,
                userSessionInitializer,
                userSessionPersistence,
                adminMiddleware,
            ),
    });
};

const createDefaultStore = () => {
    return configureStore({
        reducer: createRootReducer(),
        preloadedState: applicationInitialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    isSerializable,
                },
            }).concat(
                userSessionInitializer,
                userSessionPersistence,
                adminMiddleware,
            ),
    });
};

export const store = (getConfig() && getConfig().FRONTEND_CONFIG_ENVIRONMENT === "local") ?
    createLocalStore() : createDefaultStore();

export type AppStore = typeof store;